import clsx from 'clsx';
import { node, string } from 'prop-types';
import { useMemo } from 'react';

const Badge = ({ color, className, children }) => {
  const colorClasses = useMemo(() => {
    switch (color) {
      case 'green':
        return 'bg-primary-200 text-primary-500';
      case 'success':
        return 'bg-success-500/10 text-success-500';
      case 'yellow':
        return 'bg-yellow-100 text-yellow-500';
      case 'dark-yellow':
        return 'bg-yellow-500 opacity-90 text-white';
      case 'warning':
        return 'bg-warning-500/10 text-warning-500';
      case 'red':
        return 'bg-red-500/10 text-red-500';
      case 'gray':
        return 'bg-gray-600/10 text-gray-600';
      default:
        return 'bg-primary-200 text-primary-500';
    }
  }, [color]);

  return (
    <div
      className={clsx(
        'badge inline-block pt-2 pb-1 px-3 leading-none rounded font-bold w-fit',
        colorClasses,
        className
      )}
    >
      {children}
    </div>
  );
};

Badge.propTypes = {
  color: string.isRequired,
  children: node,
  className: string
};

export default Badge;
